import { RequestSender } from "./helpers";

export default async function getPhysicalOrders(request: RequestSender) {
  const response = await request("get", "/admin/physical-orders");
  return response.data.data; // matches endpoints.send structure
}
